<div class="table-wrapper">
  @if (schoolsTableData().length > 0) {
    <cfi-mat-table
      [allowExpand]="false"
      [columnDefinitions]="columns"
      [columnsToDisplayWithExpand]="displayedColumns"
      [data]="schoolsTableData()"
      [displayedColumns]="displayedColumns"
      [class]="getTableClasses()"
      [paginated]="false"
      [showHeader]="true"
      [sortKey]="sortKey"
      [sortDirection]="sortDir"
      [striped]="true"
      (hyperlinkClicked)="handleHyperlinkClick($event.row, $event.column)">
      <!-- Header Template -->
      <ng-template #headerTemplate let-column>
        <div class="school-cell">{{ column.header }}</div>
      </ng-template>

      <!-- Cell Template -->
      <ng-template #cellTemplate let-row let-column="column">
        @if (column.isHyperlink) {
          <div class="school-cell">
            <a
              class="hyperlink"
              tabindex="0"
              role="button"
              (click)="handleHyperlinkClick(row, column.name)"
              (keydown.enter)="handleHyperlinkClick(row, column.name)"
              (keydown.space)="handleHyperlinkClick(row, column.name)">
              {{ row[column.name] || '-' }}
            </a>
          </div>
        } @else {
          <div class="school-cell">{{ row[column.name] || '-' }}</div>
        }
      </ng-template>
    </cfi-mat-table>
  } @else {
    <div class="empty-panel">
      <div class="empty-panel-content">
        <p>No schools found for this institution.</p>
      </div>
    </div>
  }
</div>
